export default __webpack_public_path__ + "static/media/E_SDG_logo_UN_emblem_horizontal_trans_WEB.29c19209.png";